export default __webpack_public_path__ + "static/media/rogues.2411a31d.svg";